export class FileProcessingStatus {
  private _processed: number;
  private _total: number;

  constructor() {
    this._processed = 0;
    this._total  = 0;
  }

  public setProcessed(processed: number): void {
    this._processed = processed;
  }

  public setTotal(total: number): void {
    this._total = total;
  }

  public getProcessed(): number {
    return this._processed;
  }

  public getTotal(): number {
    return this._total;
  }

  public getProcessedPercent(): number {
    return Number(this._processed / this._total) * 100
  }
}
